import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AuthGuard from 'utils/route-guard/AuthGuard';
import CreatorLayout from 'layout/CreatorLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const SmartCreatorEditPage = Loadable(lazy(() => import('views/smart-creator-edit-page')));

// ==============================|| MAIN ROUTING ||============================== //

const CreatorRoutes = {
    path: '/',
    element: (
        <NavigationScroll>
            <AuthGuard>
                <CreatorLayout />
            </AuthGuard>
        </NavigationScroll>
    ),
    children: [
        {
            path: '/w/:workspaceId/creator/:type/:id',
            element: <SmartCreatorEditPage />
        }
    ]
};

export default CreatorRoutes;
